import { SET_SELECTED_TAB, RESET_STATE } from './actions';
import { DEFAULT_TAB } from '../GoalPage.constants';

const initialState = {
  selectedTab: DEFAULT_TAB,
};

export const goalReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_SELECTED_TAB: {
      return {
        ...state,
        selectedTab: payload.tab,
      };
    }

    case RESET_STATE: {
      return initialState;
    }

    default: {
      return state;
    }
  }
};
